const state = {
  type: [
    { id: 1, name: 'power', icon: 'plug' },
    { id: 2, name: 'gas', icon: 'fire' },
    { id: 3, name: 'water', icon: 'tint' },
    { id: 4, name: 'heat', icon: 'sun' },
  ],
  current: {
    loading: false,
  },
}

const actions = {
  async getCurrent({ commit }, { id, params }) {
    commit('SET_CURRENT_LOADING', true)
    try {
      let res = await this._vm.$api.get(`energetics/${id}/get`, {
        params: params,
      })
      commit('SET_CURRENT', res.data)
      return res
    } catch (e) {
      return e
    }
  },
}

const mutations = {
  SET_CURRENT_LOADING(state, loading) {
    state.current.loading = loading
  },
  SET_CURRENT(state, payload) {
    state.current = { loading: false, ...payload }
  },
}

const getters = {
  getCurrentType: (state) => {
    if (state.current.data) {
      return state.type.find((item) => item.id === state.current.data.typeID)
        .name
    }
  },
  getCurrentTypeId: (state) => {
    if (state.current.data) {
      return state.current.data.typeID
    }
  },
  getTypeByID: (state) => (id) => {
    return state.type.find((item) => item.id === id)
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
